import { Div } from "@tblabs/truffle";
import { Center } from "./Center";


export class InfoFrame extends Center
{
    constructor(title: string, content: string)
    {
        super(
            new Div("info-frame").Append(
                new Div("info-frame-title").Text(title),
                new Div("info-frame-content").Text(content)
            )
        );
    }
}
